module.exports = __webpack_public_path__ + "images/img-3PAL7ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/country.jpg
// module id = 1991
// module chunks = 0